interface ExpireIconProps {
  num: number | string;
  unit: string;
}

const ExpireIcon = ({ num, unit }: ExpireIconProps) => {
  if (!unit) {
    return null;
  }
  return (
    <svg
      width="1em"
      height="1em"
      // width="15"
      // height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <foreignObject x="-4" y="-4" width="23" height="23">
        <div
          // xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: 'blur(2px)',
            clipPath: 'url(#bgblur_0_15210_165093_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <circle
        data-figma-bg-blur-radius="4"
        cx="7.5"
        cy="7.5"
        r="7.5"
        fill="var(--expire-bg-color)"
        fillOpacity="1"
      />
      <path
        d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1"
        stroke="var(--expire-text-color)"
        strokeWidth="0.8"
        strokeDasharray="2 2"
      />
      <path
        d="M7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1"
        stroke="var(--expire-text-color)"
        strokeWidth="0.8"
      />
      <text
        // x="50%"
        // y="50%"
        x="7.5"
        y="11"
        style={{
          fill: 'var(--expire-text-color)',
          textAnchor: 'middle',
          // dominantBaseline: 'middle',
          fontWeight: '500',
          fontFamily: 'manrope',
        }}
      >
        <tspan>
          <tspan style={{ fontSize: '9px' }}>{num}</tspan>
          <tspan style={{ fontSize: '7px' }}>{unit}</tspan>
        </tspan>
      </text>
      {/* <path
        d="M4.2595 11V5.4065L3.04 6.1445V5.249L4.2595 4.52H5.074V11H4.2595ZM7.45125 11L6.29625 7.2165L6.91575 7.22L7.75925 9.985L8.60975 7.22H9.15925L10.0063 9.985L10.8533 7.22H11.4693L10.3143 11H9.79625L8.88275 8.1265L7.96925 11H7.45125Z"
        fill="var(--expire-text-color)"
      /> */}
      <defs>
        <clipPath id="bgblur_0_15210_165093_clip_path" transform="translate(4 4)">
          <circle cx="7.5" cy="7.5" r="7.5" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MemoExpireIcon = memo(ExpireIcon);

export { MemoExpireIcon as ExpireIcon };
